import { render, staticRenderFns } from "./TrekkingAgencyList.vue?vue&type=template&id=4ba12f18&"
import script from "./TrekkingAgencyList.vue?vue&type=script&lang=js&"
export * from "./TrekkingAgencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports